import { Component, OnInit, Input, Output } from "@angular/core";
import { Router } from "@angular/router";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { AuthService } from "../../service/auth.service";
import { GeneralService } from "../../service/general.service";
import { FormsModule } from "@angular/forms";


@Component({
    selector: "decline-dialog",
    templateUrl: "../../../html/incs/decline-dialog.html",
    imports: [FormsModule]
})
export class DeclineDialog implements OnInit {
    declineReasons: string = "";
    public declineTitle: string = "Decline";
    public declineMessage:string = "";
    public declineButton: string = "Decline";

    constructor(public dialogRef: MatDialogRef<DeclineDialog>,
        private router: Router,
        private authService: AuthService,
        private generalService: GeneralService
    ) {}

    ngOnInit(): void {
        if (!this.authService.isLoggedIn()) {
            this.router.navigate(["/user/login"], { queryParams: { redirect: this.router.url } });
        }
    }

    confirm() {
      this.dialogRef.close(this.declineReasons);
    }

    closeDialog() {
      this.dialogRef.close(null);
    }
}